export default __webpack_public_path__ + "static/media/csharp.a13617fc.svg";